import PageHero from "../components/PageHero.jsx";
import CTA from "../components/CTA.jsx";

const beliefs = [
  "Smarter preservation",
  "Cleaner formulations",
  "Stronger sourcing systems",
  "Long-term global partnerships"
];

export default function ExportSourcing() {
  return (
    <>
      <PageHero
        eyebrow="Export & sourcing"
        title="Built around sourcing intelligence."
        text="Our focus is not just processing — but understanding sourcing ecosystems, ingredient consistency and export-focused execution."
        image="/images/premium-powders.jpg"
      />

      <section className="content-band">
        <div className="section-inner two-column">
          <div>
            <p className="eyebrow">Export positioning</p>
            <h2>The future of food ingredients needs better systems.</h2>
          </div>
          <div className="copy-stack">
            <p>
              We believe the future of food ingredients lies in smarter preservation, cleaner
              formulations, stronger sourcing systems and long-term global partnerships.
            </p>
            <div className="signal-grid">
              {beliefs.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CTA />
    </>
  );
}
